import * as React from 'react'

export const ConnectComponent = (View: any, Presenter: new () => LifecyclePresenter<LifecycleView>) => {
  class ConnectedComponent extends React.Component<any, {}> {
    private readonly presenter: LifecyclePresenter<LifecycleView>

    constructor(props: any) {
      super(props)

      this.presenter = new Presenter()
    }

    componentDidMount() {
      if (typeof this.presenter.onLifecycleStart === 'function') {
        this.presenter.onLifecycleStart()
      }
    }

    componentWillUnmount() {
      if (typeof this.presenter.onLifecycleStop === 'function') {
        this.presenter.onLifecycleStop()
      }
    }

    render() {
      const propsWithPresenter = { ...this.props, presenter: this.presenter }
      return <View {...propsWithPresenter} />
    }

    static displayName = `ConnectComponent(${View.name}, ${Presenter.name})`
  }

  return ConnectedComponent
}

export interface LifecycleView {}

export interface LifecyclePresenter<View extends LifecycleView, P = {}> {
  initialize?: (view: View, params: P) => void
  onLifecycleStart?: () => void
  onLifecycleStop?: () => void
}
